module.exports = __webpack_public_path__ + "edfab27cf5852a4b7045cf98bb4e9f0c.png";